import { render, staticRenderFns } from "./preview-customer.vue?vue&type=template&id=5e297908&scoped=true&"
import script from "./preview-customer.vue?vue&type=script&lang=js&"
export * from "./preview-customer.vue?vue&type=script&lang=js&"
import style0 from "./preview-customer.vue?vue&type=style&index=0&id=5e297908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e297908",
  null
  
)

export default component.exports